interface MediaItem {
  image: string;
  title: string;
  duration: string;
  views: string;
  tag: string;
}

const mediaItems: MediaItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Video%20player%20interface%20with%20entertainment%20news%20content%2C%20play%20button%20overlay%2C%20warm%20cinematic%20lighting%2C%20breaking%20news%20aesthetic%2C%20clean%20editorial%20style%2C%20no%20text%2C%20modern%20video%20platform%20design&width=800&height=450&seq=media-01&orientation=landscape',
    title: '某顶流男星深夜密会视频完整版流出',
    duration: '03:28',
    views: '256.8万',
    tag: '独家',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Talk%20show%20studio%20with%20two%20chairs%20and%20dramatic%20lighting%2C%20interview%20concept%2C%20warm%20atmosphere%2C%20editorial%20style%2C%20no%20text%2C%20professional%20broadcast%20setting&width=800&height=450&seq=media-02&orientation=landscape',
    title: '业内人士独家专访：选秀节目黑幕全揭秘',
    duration: '12:45',
    views: '189.3万',
    tag: '专访',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Stage%20performance%20with%20dramatic%20lighting%20and%20audience%20silhouettes%2C%20concert%20concept%2C%20warm%20energetic%20atmosphere%2C%20editorial%20style%2C%20no%20text%2C%20live%20show%20vibe&width=800&height=450&seq=media-03&orientation=landscape',
    title: '颁奖礼现场冲突：两大流量当场翻脸实拍',
    duration: '05:12',
    views: '421.6万',
    tag: '实拍',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=News%20debate%20panel%20with%20multiple%20people%20discussing%2C%20analysis%20concept%2C%20warm%20studio%20lighting%2C%20editorial%20style%2C%20no%20text%2C%20professional%20news%20discussion%20setting&width=800&height=450&seq=media-04&orientation=landscape',
    title: '吃瓜大神直播解析：如何辨别真假爆料',
    duration: '22:10',
    views: '98.5万',
    tag: '直播',
  },
];

const SectionMedia = () => (
  <section id="media" className="py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">视频速递</h2>
        <p className="mt-2 text-sm text-foreground-500">热门吃瓜视频，一手掌握</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {mediaItems.map((item) => (
          <div key={item.title} className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer">
            <div className="relative overflow-hidden">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-44 md:h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-foreground-900/20 group-hover:bg-foreground-900/30 transition-colors flex items-center justify-center">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-xl ml-0.5"></i>
                </span>
              </div>
              <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">{item.tag}</span>
              <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-900/70 text-background-50 text-xs">{item.duration}</span>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
              <p className="mt-1.5 text-xs text-foreground-400">{item.views} 次播放</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SectionMedia;